import { useMemo } from 'react';
import { useCoupons } from '@/Coupons/hooks/use-coupons';
import { findMatchingCoupons } from '../lib/coupon-matching';
import type { Recipe } from '../types/recipes';
import type { Coupon } from '@/Coupons/types/coupons';

interface UseRecipeCouponsResult {
  matchingCoupons: Coupon[];
  hasMatches: boolean;
  isLoading: boolean;
}

export function useRecipeCoupons(recipe: Recipe | null): UseRecipeCouponsResult {
  // Reuse the existing useCoupons hook which handles location fallback
  const { data: allCoupons = [], isLoading } = useCoupons();

  const matchingCoupons = useMemo(() => {
    if (!recipe?.RecipeIngredients?.length || !allCoupons.length) {
      return [];
    }
    return findMatchingCoupons(recipe.RecipeIngredients, allCoupons);
  }, [recipe?.RecipeIngredients, allCoupons]);

  return {
    matchingCoupons,
    hasMatches: matchingCoupons.length > 0,
    isLoading,
  };
}
